export enum  StatusEnum{
    OPEN = 'OPEN',
    ASSIGN_TO_APPROVAL = 'ASSIGN TO APPROVAL',
    SENT_FOR_APPROVAL = 'SENT FOR APPROVAL',
    CANCELED = 'CANCELED',
    REJECTED = 'REJECTED',
    SENT_FOR_SECURITY_CHECK = 'SENT FOR SECURITY CHECK',
    READY_TO_RECEIVE = 'READY TO RECEIVE',
    RECEIVED ='RECEIVED',
    SENT_FOR_SECURITY_RE_CHECK ='SENT FOR SECURITY RE CHECK',
    READY_TO_RE_RECIEVE ='READY TO RE RECEIVE',
    RETURNED ='RETURNED',
    READY_TO_RETURN = 'READY TO RETURN',
    NOT_RETURNED = 'NOT RETURNED',
    CLOSED = 'CLOSED',
    SENT_FOR_SECURITY_CHECK_IN = 'SENT FOR SECURITY CHECK IN',
    SENT_FOR_SECURITY_RE_CHECK_IN = 'SENT FOR SECURITY RE CHECK IN',
}